<template>
  <div class="share">
    <div ref="shareBox" class="share-box" :style="'background-image: url('+require('./../../../assets/share/share-bg-'+bgNum+'.jpg')+')'">
      <div class="share-head" :class="{'dark': textDark}">
        <div class="avatar">
          <van-uploader v-if="!previewMode" ref="uploadAvatar" v-model="leadInfo.avatarList" accept="image/*" upload-text="头像" :preview-full-image="false" :max-size="5 * 1024 * 1024" :max-count="1" :after-read="afterReadAvatar" @oversize="onOversize" />
          <van-image v-else round :src="leadInfo.profileData64" fit="cover" />
        </div>
        <div>
          <h4 class="name">{{ leadInfo.leadName }}</h4>
          <div class="info">坚持打卡天数：<strong>{{ leadInfo.shareDatesCount }}</strong></div>
        </div>
        <div class="date"><small>{{ today }}</small><br>{{ weekDay }}</div>
      </div>
      <div class="share-text">
        <h4>我的今日学习打卡：</h4>
        <div class="input-box">
          <van-image class="quote-left" :src="quoteLeft" width="0.6rem" />
          <blockquote ref="inputBox" class="share-words">{{ shareWordList[currentWordIndex] }} </blockquote>
          <van-image class="quote-right" :src="quoteRight" width="0.6rem" />
        </div>
        <div class="signature">- You Plus Anchor Explorer</div>
      </div>
      <div class="share-foot">
        <div class="foot-logo">
          <van-image width="3.7rem" height="0.7rem" fit="contain" :src="logoWhiteImg" />
          即刻扫码免费预约职业规划咨询，找到你的<br>“金句老师”，获取求职干货
        </div>
        <img class="qr-code" :src="'data:image/png;base64,'+leadInfo.qrData64">
      </div>
    </div>
    <div class="download-btn">
      <button class="btn" @click="createPoster">生成海报图片</button>
      <el-button type="text" class="btn2" icon="el-icon-refresh" @click="changeWord">换一换</el-button>
    </div>
    <van-dialog v-model="showDialog" title="请选择今日金句" message-align="left" @confirm="closeDialog" @close="closeDialog">
      <ul class="share-word-list">
        <li v-for="(item,index) in shareWordList" :key="index" :class="{'active': currentWordIndex === index}" @click="selectWord(item,index)">{{ item }}</li>
      </ul>
    </van-dialog>
    <van-popup v-model="showPopup" :close-on-click-overlay="false" closeable :lock-scroll="true" :style="{ padding: '.2rem .2rem' }">
      <img :src="imgUrl" :width="imgWidth-80" height="auto">
      <div v-if="isWeb" style="color:#d93954; text-align: center;">请右键“另存为”保存图片</div>
      <div v-else style="color:#d93954; text-align: center;">请长按图片保存至手机</div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Image, Uploader, Loading, Toast, Popup, Notify, Dialog, Field } from 'vant'
import logoImg from '@/assets/logo.png'
import logoWhiteImg from '@/assets/logo-white.png'
import quoteLeft from '@/assets/quote-left.png'
import quoteRight from '@/assets/quote-right.png'
import html2canvas from 'html2canvas'
import { sharingUploadFile } from '@/api/file'
import { http } from '@/api'
import { Sharing } from '@/api/collection'
import { formatDate } from '@/util/date'

export default {
  name: 'Share',
  components: {
    [Image.name]: Image,
    [Uploader.name]: Uploader,
    [Loading.name]: Loading,
    [Popup.name]: Popup,
    [Field.name]: Field
  },
  props: {
    isWeb: {
      type: Boolean,
      default: false
    },
    showImg: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      title: ['PwC You Plus', 'Share'],
      bg: '',
      showDialog: false,
      previewMode: false,
      showPopup: false,
      imgUrl: '',
      imgWidth: '',
      imgHeight: '',
      userName: '',
      logoImg,
      logoWhiteImg,
      quoteLeft,
      quoteRight,
      leadInfo: {
        leadName: '',
        shareDatesCount: 0,
        avatarList: [],
        profileData64: '',
        qrData64: ''
      },
      shareWordList: [],
      currentWordIndex: null,
      bgNum: 1,
      textDark: false
    }
  },
  computed: {
    ...mapState(['userInfo']),
    today() {
      let date = new Date()
      date = formatDate(date, 'yyyy-MM-dd')
      return date
    },
    weekDay() {
      const now = new Date()
      const day = now.getDay()
      const weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const week = weeks[day]
      return week
    }
  },
  watch: {
    bgNum(val) {
      // 判断需要使用黑字的背景图
      const array = [7, 10, 11, 14, 15, 16, 17, 18, 20]
      if (array.includes(val)) {
        this.textDark = true
      } else {
        this.textDark = false
      }
    }
  },
  created() {
    // 随机背景图
    const num = Math.floor(Math.random() * 22)
    this.bgNum = num
  },
  async mounted() {
    if (this.userInfo && this.userInfo.token && this.userInfo.leadId) {
      console.log('已登录')
    } else {
      // 要答案 需要登录
      this.$router.push({
        path: '/reallyAlumniLogin',
        query: { redirect: this.$route.fullPath },
        replace: true
      })
      return
    }
    Toast.loading({
      message: '加载中...',
      duration: 5000,
      forbidClick: true
    })
    await this.getLeadInfo()
    await this.getSharingWords()
    Toast.clear()
  },
  methods: {
    // 获取学生信息
    async getLeadInfo() {
      const res = await http({
        path: Sharing.GetInfoById.path,
        method: Sharing.GetInfoById.method,
        data: {}
      })
      if (res.resultCode === '0') {
        const resData = res.data
        this.leadInfo.leadName = resData.leadName
        this.leadInfo.shareDatesCount = resData.shareDatesCount
        if (resData.profileData64) {
          this.leadInfo.avatarList[0] = { url: resData.profileUrl }
          this.leadInfo.profileData64 = 'data:image/jpg;base64,' + resData.profileData64
        }
        this.leadInfo.qrData64 = resData.qrData64
      }
    },
    // 选择金句
    async getSharingWords() {
      const res = await http({
        path: Sharing.GetSharingWords.path,
        method: Sharing.GetSharingWords.method,
        data: {}
      })
      if (res.resultCode === '0') {
        this.shareWordList = res.datas
        this.showDialog = true
      }
    },
    selectWord(word, index) {
      this.currentWordIndex = index
    },
    // 选择金句
    closeDialog() {
      if (this.currentWordIndex === null) {
        Notify('请选择一条金句！')
        this.showDialog = true
      } else {
        console.log('close')
      }
    },
    // 头像超过大小提示
    onOversize(file) {
      Notify('请上传小于5M的文件')
    },
    // 上传头像
    async afterReadAvatar() {
      if (this.leadInfo.avatarList.length > 0) {
        const fd = new FormData()
        this.leadInfo.avatarList.forEach((item) => {
          fd.append('files', item.file)
        })
        const res = await sharingUploadFile(fd)
        if (res && res.resultCode === '0') {
          console.log('头像上传成功')
          // await this.getLeadInfo()
        } else {
          console.log('头像上传失败')
        }
      } else {
        Toast.fail('请选择头像')
      }
    },
    // 判断是否有头像
    async createPoster() {
      if (this.leadInfo.avatarList.length === 0) {
        Dialog.confirm({
          title: '请上传头像',
          message: '上传头像后，生成海报效果会更好哦！',
          confirmButtonText: '上传头像'
        }).then(() => {
          this.$refs['uploadAvatar'].chooseFile()
        })
      } else {
        Toast.loading({
          message: '生成海报...',
          duration: 0,
          forbidClick: true
        })
        await this.updateInfo() // 打卡
        await this.getLeadInfo() // 获取个人信息
        await this.generateImg() // 生成图片
      }
    },
    // 生成图片
    generateImg() {
      this.previewMode = true
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
      this.$nextTick(() => {
        const box = this.$refs.shareBox
        this.imgWidth = box.clientWidth // 获取dom宽度
        this.imgHeight = box.clientHeight // 获取dom高度
        const opts = {
          scale: 3, // 定义任意放大倍数 支持小数
          width: this.imgWidth,
          height: this.imgHeight,
          scrollX: 0,
          scrollY: 0,
          dpi: 72
        }
        setTimeout(() => {
          html2canvas(box, opts)
            .then((canvas) => {
              this.imgUrl = canvas.toDataURL('image/png', 1)
              this.previewMode = false

              // 弹出显示图片
              if (this.showImg) {
                this.showPopup = true
              }

              // 下载图片（微信上无效）
              const fileName = '海报分享-' + new Date().getTime() + '.jpg'
              const link = document.createElement('a')
              link.href = this.imgUrl // 下载链接
              link.setAttribute('download', fileName)
              link.style.display = 'none'
              document.body.appendChild(link)
              link.click()
              this.previewMode = false

              // Toast.clear()
              Toast.success({
                message: '图片生成成功',
                duration: 2000,
                forbidClick: true
              })
            })
            .catch((err) => {
              console.log(err)
            })
        }, 600)
      })
    },
    // 打卡
    async updateInfo() {
      const res = await http({
        path: Sharing.UpdateInfo.path,
        method: Sharing.UpdateInfo.method,
        data: {}
      })
      if (res.resultCode === '0') {
        console.log(res.resultMsg)
      }
    },
    // 换背景图和金句
    changeWord() {
      if (this.bgNum < 22) {
        this.bgNum++
      } else {
        this.bgNum = 1
      }

      if (this.currentWordIndex < this.shareWordList.length - 1) {
        this.currentWordIndex++
      } else {
        this.currentWordIndex = 0
      }
    }
  }
}
</script>
<style>
.share {
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 0.4rem;
  font-size: 0.28rem;
  line-height: 170%;
}
.share .van-uploader__upload,
.share .van-uploader__preview-image {
  width: 1.2rem;
  height: 1.2rem;
  margin: 0;
}
.share-word-list {
  margin: 0.2rem 0.3rem 0;
  padding: 0.2rem 0;
  font-size: 0.28rem;
  line-height: 150%;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
}
.share-word-list li {
  margin-bottom: 0.2rem;
  padding: 0.2rem 0.25rem;
  cursor: pointer;
  background-color: #f5f5f5;
}
.share-word-list li.active {
  color: #d04a02;
  font-size: 0.3rem;
  font-weight: bold;
  background-color: rgb(208, 74, 2, 0.1);
}
.share .share-box {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 11rem;
}
.share .share-box .van-uploader__upload,
.share .share-box .van-image {
  border-radius: 50%;
}
.share .van-uploader__preview-image img {
  min-height: 100%;
  height: auto;
}
.share .upload-box {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  text-align: center;
}
.share .btn {
  width: 2.4rem;
  min-height: 35px;
  height: 0.7rem;
  margin: 0.2rem 0;
  border-radius: 0.44rem;
  border: 1px solid #d04a02;
  color: #d04a02;
  line-height: 0.7rem;
}
.share .btn:hover,
.share .btn:active {
  background-color: #d04a02;
  color: #fff;
}
.share .upload-box .foot-logo {
  height: auto;
  margin: 0.6rem 1.6rem 0.4rem;
}
.share .upload-box .upload-content {
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  flex-grow: 1;
  padding-bottom: 1.4rem;
}
.share .upload-box .upload-content h2 {
  margin-bottom: 0.3rem;
  font-size: 0.44rem;
  line-height: 130%;
  font-family: Georgia, 'Microsoft Yahei';
}
.share .upload-box .upload-content p {
  margin-bottom: 0.2rem;
  color: #444;
}
.share .share-box {
  position: relative;
  background-color: #000;
  background-position: center top;
  background-repeat: no-repeat;
  background-size: 100% auto;
}
.share .share-head {
  display: flex;
  align-items: center;
  margin-bottom: 0.6rem;
  padding: 0.5rem;
  color: #fff;
  font-size: 0.34rem;
}
.share .share-head.dark {
  color: #000;
}
.share .share-head .name {
  font-size: 0.4rem;
  margin: 0.1rem 0;
  text-shadow: #000 0 0 10px 5px;
}
.share .share-head .info {
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.28rem;
}
.share .share-head.dark .info {
  color: rgba(0, 0, 0, 0.8);
}
.share .avatar {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 0.3rem;
}
.share .avatar .van-uploader__upload-text {
  margin-top: 0;
}
.share .avatar img {
  width: 1.2rem;
  height: 1.2rem;
}
.share .share-head .date {
  margin-left: auto;
  padding: 0.04rem 0.16rem;
  font-size: 0.24rem;
  line-height: 150%;
  border: 1px solid rgba(255, 255, 255, 0.4);
}
.share .share-head.dark .date {
  border: 1px solid rgba(0, 0, 0, 0.4);
}
.share .share-text {
  margin: auto 0.5rem 0.5rem;
  padding: 0.5rem;
  background-color: rgba(0, 0, 0, 0.6);
}
.share .share-text h4 {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.28rem;
  font-weight: normal;
  margin-bottom: 0.1rem;
}
.share .share-text .input-box {
  display: flex;
  width: 100%;
  min-height: 1em;
  margin: 10px 0;
}
.share .share-text .input-box .quote-left {
  flex-shrink: 0;
  flex-grow: 0;
  align-self: flex-start;
}
.share .share-text .input-box .quote-right {
  flex-shrink: 0;
  flex-grow: 0;
  align-self: flex-end;
}
.share .share-text .input-box .van-image img {
  opacity: 0.7;
}
.share .share-text .input-box .share-words {
  color: #fff;
  font-size: 0.36rem;
  line-height: 150%;
  text-align: justify;
  padding: 10px;
}
.share .share-text .signature {
  color: #fff;
  font-size: 0.28rem;
  text-align: right;
  font-family: Georgia;
}
.share .share-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.4rem;
  background-color: rgba(0, 0, 0, 0.8);
  font-family: Georgia, sans-serif;
}
.share .share-foot .foot-logo {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.24rem;
  font-weight: normal;
  line-height: 150%;
}
.share .share-foot .foot-logo .van-image {
  margin-bottom: 0.2rem;
}
.share .share-foot .qr-code {
  width: auto;
  height: 1.5rem;
  margin-left: 0.2rem;
}
.share .download-btn {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 0.2rem;
  padding: 0 0.3rem;
}
.share .download-btn button {
  flex-grow: 1;
  height: 1rem;
  color: #fff;
  font-size: 0.4rem;
  border-radius: 0.5rem;
}
.share .download-btn button.btn {
  background-color: #d93954;
}
.share .download-btn button.btn:hover,
.share .download-btn button.btn:active {
  background-color: #eb8c00;
  border-color: #eb8c00;
}
.share .download-btn button.btn2 {
  flex-grow: 0;
  margin-left: 0.2rem;
  color: #d93954;
  font-size: 0.28rem;
}
/* .share .download-btn button.btn2 {
  background-color: #ffb600;
}
.share .download-btn button.btn2:hover,
.share .download-btn button.btn2:active {
  background-color: #eb8c00;
} */
</style>
